import styled from "styled-components";
import HolographicBg from "../../assets/KRF-holographic-bg.jpg";
import { siteDarkBlue, sitePurple } from "../../providers/Theme";

export const Section = styled.section`
  background: ${siteDarkBlue};
  padding: 4rem 1.5rem 3rem;
  overflow: hidden;
`;

export const SectionHeading = styled.h2`
  color: white;
  font-weight: 800;
  font-size: 2rem;
  margin-bottom: 2.5rem;
  text-align: center;
  line-height: 1.2;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}
`;

export const HeadingAccent = styled.span`
  background-image: url(${HolographicBg});
  background-size: 300% 600%;
  background-position: 40% 58%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  filter: brightness(0.82) saturate(1.3) hue-rotate(-35deg);
`;

export const CarouselWrapper = styled.div`
  max-width: 72rem;
  margin: 0 auto;
`;

export const Track = styled.div`
  display: flex;
  gap: 1.25rem;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding-bottom: 0.25rem;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const QuoteCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.75rem;
  flex: 0 0 calc(100%);
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.md`
    flex: 0 0 calc(33.333% - 0.84rem);
  `}
`;

export const QuoteMark = styled.div`
  color: ${sitePurple};
  font-size: 3rem;
  line-height: 0.8;
  font-family: Georgia, serif;
  font-weight: 700;
  margin-bottom: 0.75rem;
`;

export const QuoteText = styled.p`
  color: ${siteDarkBlue};
  font-size: 1.35rem;
  line-height: 1.6;
  flex: 1;
  margin-bottom: 1.25rem;
`;

export const Attribution = styled.div``;

export const AttrName = styled.p`
  color: ${sitePurple};
  font-weight: 700;
  font-size: 0.95rem;
  margin-bottom: 0.1rem;
`;

export const AttrTitle = styled.p`
  color: ${siteDarkBlue};
  font-weight: 700;
  font-size: 0.9rem;
  margin-bottom: 0.1rem;
`;

export const AttrOrg = styled.p`
  color: ${siteDarkBlue};
  font-size: 0.9rem;
  margin: 0;
`;

export const NavRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

export const Dots = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const Dot = styled.button<{ active: boolean }>`
  width: ${({ active }) => (active ? "24px" : "10px")};
  height: 10px;
  border-radius: 5px;
  border: none;
  background: ${({ active }) => (active ? "white" : "rgba(255,255,255,0.35)")};
  cursor: pointer;
  padding: 0;
  transition:
    width 0.25s ease,
    background 0.25s ease;
`;

export const NavButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid white;
  background: transparent;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.1rem;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: white;
    color: ${siteDarkBlue};
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;
